module.exports = __webpack_public_path__ + "img/crescimento_pessoal.95599638.svg";